module.exports = __webpack_public_path__ + "img/131.03295b1b.jpg";